import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'SearchSalesReportBroker',
  components: {
    AutocompleteZ
  },
  mixins: [ActionsForm, ExpenseMixin],
  data () {
    return {
      title: 'Buscar Relatório',
      dataEnterprise: [],
      enteprise: [],
      formsearch: {
        nome: '',
        DtInicial: '',
        DtFinal: '',
        empreendimentoId: localStoreHelper.imobiliaria.relatorioVendasCorretor() != null ? localStoreHelper.imobiliaria.relatorioVendasCorretor(this.formsearch).empreendimentoId : '',
        corretorId: '',
        corretor: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      onlyTable: false,
      CustomData: false,
      typeSearch: ''
    }
  },
  mounted () {
    this.GetAllEnterprise()
  },
  methods: {
    filter (obj) {
      this.typeSearch = obj.target.id
      if (obj.target.id === 'semanal') {
        const now = new Date()
        var diferencaPSegunda = now.getDay() - 1
        var diferencaPSexta = (5 - now.getDay())
        const monday = new Date()
        monday.setDate(now.getDate() - diferencaPSegunda)

        const friday = new Date()
        friday.setDate(now.getDate() + diferencaPSexta)

        this.formsearch.DtInicial = monday
        this.formsearch.DtFinal = friday
        this.dataspersonalizadas = false
        this.CustomData = false
      }

      if (obj.target.id === 'mensal') {
        const now = new Date()
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

        this.formsearch.DtFinal = lastDay
        this.formsearch.DtInicial = firstDay
        this.CustomData = false
      }

      if (obj.target.id === 'anual') {
        const now = new Date()
        const firstDay = new Date(now.getFullYear(), 0, 1)
        const lastDay = new Date(now.getFullYear(), 11, 31)
        this.formsearch.DtFinal = lastDay
        this.formsearch.DtInicial = firstDay

        this.CustomData = false
      }

      if (obj.target.id === 'personalizado') {
        this.CustomData = true
      }

      let id = obj.target.id
      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.getElementById(id).classList.toggle('btn-periodos')
      document.getElementById(id).classList.toggle('btn-periodos-active')
    },
    GetAllEnterprise () {
      RequestsRepository.GetAllEnterprisesByApprovedRequest()
        .then(Response => {
          this.enteprise = Response.data.data
        })
        .catch(() => {})

      ProposalRepository.GetCorretorByNameSalesReports()
        .then(Response => {
          this.corretor = Response.data.data
        })
        .catch(() => {})
    },
    setSearch (newValue) {
      this.$emit('setSearch', newValue)
    },
    setCustomDate (newValue) {
      this.$emit('setCustomDate', newValue)
    },
    Clear () {
      localStoreHelper.imobiliaria.relatorioVendasCorretor()
      this.$refs.CorretorSalesReportsTypeahead.clear()
      Object.keys(this.formsearch).forEach(props => {
        if (props === 'corretor') {
          this.formsearch[props].value = ''
        } else {
          this.formsearch[props] = ''
        }
      })

      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.querySelector('#anual').classList.add('btn-periodos-active')
      document.querySelector('#anual').classList.remove('btn-periodos')

      // const now = new Date()
      // const firstDay = new Date(now.getFullYear(), 0, 1)
      // const lastDay = new Date(now.getFullYear(), 11, 31)
      // this.formsearch.DtFinal = lastDay
      // this.formsearch.DtInicial = firstDay

      this.setCustomDate(false)
      this.setSearch(false)
      this.$emit('search', this.formsearch, true)
      this.showDate = false
      this.formsearch.filterweek = false
    },
    Search () {
      this.formsearch.corretorId = this.formsearch.corretor.value
      this.onlyTable = false
      if (this.formsearch.empreendimentoId !== '' || this.formsearch.corretorId !== null) {
        this.onlyTable = true
        if (this.CustomData === false) {
          this.formsearch.DtInicial = ''
          this.formsearch.DtFinal = ''
        }
      }
      if (this.typeSearch === 'semanal' || this.typeSearch === 'mensal') {
        this.onlyTable = true
        if (this.CustomData === false) {
          this.formsearch.DtInicial = ''
          this.formsearch.DtFinal = ''
        }
      }
      this.setCustomDate((this.typeSearch === 'personalizado'))
      this.setSearch(this.onlyTable)
      this.$emit('search', this.formsearch, false)
      localStoreHelper.imobiliaria.relatorioVendasCorretor(this.formsearch)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesreportsbroker/components/searchsalesreportbroker/searchsalesreportbroker.js